import {
  enableFormTracking,
} from '@snowplow/browser-plugin-form-tracking';

import {
  trackSelfDescribingEvent,
  trackStructEvent,
  trackPageView,
} from '@snowplow/browser-tracker';

import * as defaultContexts from './default-contexts';

/**
 * Contexts can be passed as array containing
 * strings of default contexts or as context objects.
 * @param {Array} contexts - Array of contexts to include
 * @returns {Array} - snowplow context array
 */
const createContext = (contextsArray = []) => {
  const contexts = [];

  contextsArray.forEach((item) => {
    const itemType = typeof item;
    if (itemType === 'string') {
      const context = defaultContexts[item];
      if (context) {
        contexts.push(context());
      }
    } else if (itemType === 'object') {
      contexts.push(item);
    } else {
      // eslint-disable-next-line no-console
      console.warn(`Context option ${JSON.stringify(item)} should be a default context lookup string or a valid context definition object.`);
    }
  });

  return contexts;
};

/**
 * Creates tracker for a specified event
 * @param {object} config - tracker options
 * @param {string} config.tracker - Tracker function to be used
 * @param {Object} config.data - event data
 * @param {Array} [config.context=[]] - Contexts to include
 * @param {Array} [config.options={}] - Options to include
 * @param {Array} [config.options.once]
 * When set to true the event won't fire on reload
  */
const createTracker = ({
  tracker,
  data = {},
  context = [],
  options = {},
}) => {
  // "performance.navigation" is deprecated, but the modern
  // PerformanceNavigationTiming is not yet on Safari.
  if (
    options.once &&
      window.performance.navigation &&
      window.performance.navigation.type ===
      window.performance.navigation.TYPE_RELOAD
  ) {
    return () => {};
  }

  switch (tracker) {
    case 'trackStructEvent':
      return () => {
        data.context = createContext(context);
        trackStructEvent(data);
      };
    case 'trackSelfDescribingEvent':
      return () => trackSelfDescribingEvent({
        event: data,
        context: createContext(context),
        options,
      });
    case 'trackPageView':
      return () => trackPageView({
        context: createContext(context),
        options,
      });
    case 'enableFormTracking':
      return () => (enableFormTracking({ options, context: createContext(context) }));
    default:
      throw new Error('Specified tracker was not found.');
  }
};

export {
  createTracker,
  enableFormTracking,
  trackSelfDescribingEvent,
  trackStructEvent,
  trackPageView,
};
